import { FarmaError } from 'src/integracoes/modelos/erros';
import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import {
  HttpsCallableResult,
  getFunctions,
  httpsCallable
} from 'firebase/functions';
import {
  IUsuarioFirebase,
  IUsuarioFormulario,
  IUsuarioMongoDB
} from 'src/integracoes/modelos/usuarios';
import { app } from './app';
import { montaUsuarioFirebase } from './utils';

const functions = getFunctions(app, 'southamerica-east1');

const obtemUsuariosFirebase = async (
  empId: string
): Promise<IRespostaFuncao<IUsuarioFirebase[] | FarmaError>> => {
  const funcao = httpsCallable(functions, 'usuarios-obtemUsuarios-v1');
  const resposta = funcao({ empresa: empId })
    .then((result: HttpsCallableResult) => {
      const resp: IRespostaFuncao<any> = result.data as IRespostaFuncao<any>;
      if (!resp.status) {
        throw new FarmaError(resp.dados);
      }
      return resp;
    })
    .catch((erro: any) => {
      throw new FarmaError(erro);
    });
  return resposta;
};

const criaUsuarioFirebase = async (
  usuarioFirebase: IUsuarioFirebase
): Promise<IRespostaFuncao<IUsuarioFirebase | FarmaError>> => {
  const funcao = httpsCallable(functions, 'usuarios-criaUsuario-v1');
  const resposta = funcao(usuarioFirebase)
    .then((result: HttpsCallableResult) => {
      const resp: IRespostaFuncao<any> = result.data as IRespostaFuncao<any>;
      if (!resp.status) {
        throw new FarmaError(resp.dados);
      }
      return resp;
    })
    .catch((erro: any) => {
      throw new FarmaError(erro);
    });
  return resposta;
};

const atualizaUsuarioFirebase = async (
  usuarioFormulario: IUsuarioFormulario
): Promise<IRespostaFuncao<IUsuarioFirebase | FarmaError>> => {
  const funcao = httpsCallable(
    functions,
    'usuarios-atualizaUsuario-v1'
  );
  const usuarioFirebase: IUsuarioFirebase = montaUsuarioFirebase(
    usuarioFormulario
  );
  const resposta = funcao(usuarioFirebase)
    .then((result: HttpsCallableResult) => {
      const resp: IRespostaFuncao<any> = result.data as IRespostaFuncao<any>;
      if (!resp.status) {
        throw new FarmaError(resp.dados);
      }
      return resp;
    })
    .catch((erro: any) => {
      throw new FarmaError(erro);
    });
  return resposta;
};

const removeUsuarioFirebase = async (
  email: string
): Promise<IRespostaFuncao<IUsuarioFirebase | FarmaError>> => {
  const funcao = httpsCallable(functions, 'usuarios-removeUsuario-v1');

  const resposta = funcao({ email })
    .then((result: HttpsCallableResult) => {
      const resp: IRespostaFuncao<any> = result.data as IRespostaFuncao<any>;
      if (!resp.status) {
        throw new FarmaError(resp.dados);
      }
      return resp;
    })
    .catch((erro: any) => {
      throw new FarmaError(erro);
    });
  return resposta;
};

const enviaEmailAtivacao = async (
  usuarioFormulario: IUsuarioFormulario
): Promise<IRespostaFuncao<IUsuarioMongoDB | FarmaError>> => {
  const funcao = httpsCallable(
    functions,
    'transacional-enviaEmailAtivacao-v1'
  );
  const { email } = montaUsuarioFirebase(usuarioFormulario);
  const resposta = funcao({ name: email, email })
    .then((result: HttpsCallableResult) => {
      const resp: IRespostaFuncao<any> = result.data as IRespostaFuncao<any>;
      if (!resp.status) {
        throw new FarmaError(resp.dados);
      }
      return resp;
    })
    .catch((erro: any) => {
      throw new FarmaError(erro);
    });
  return resposta;
};

export {
  obtemUsuariosFirebase,
  criaUsuarioFirebase,
  atualizaUsuarioFirebase,
  removeUsuarioFirebase,
  enviaEmailAtivacao,
};
